import padlock from "./padlock.svg";
import "./index.css";

export function CloseSection() {
  return (
    <>
      <div className="closeSectionConteiner">
        <img src={padlock} alt=""/>
        <h4 className="textAlignCenter">Пройдите все качества, которые выше, чтобы открыть доступ!</h4>
      </div>
    </>
  );
}



